import React from 'react';
import { Box } from '@material-ui/core';


export const TabPanel = (props) => {
    const { children, value, index, paddingBox = 3, keepMounted = false, style, ...other } = props;
    const active = value === index;

    React.useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, [active]);

    return (
        <div
            role="tabpanel"
            hidden={!active}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            style={{ overflowY: 'auto', display: active ? 'block' : 'none', ...style }}
            {...other}
        >
            {keepMounted && (
                <Box p={paddingBox}>
                    {children}
                </Box>
            )}
            {!keepMounted && value === index && (
                <Box p={paddingBox}>
                    {children}
                </Box>
            )}
        </div>
    );
};